import React from 'react'

class Credits extends React.Component{
	render(){
		return(
			<footer className="">© 2017 Julian Salinas, all rights reserved.</footer>
		)
	}
}
export default Credits


// WEBPACK FOOTER //
// ./src/Credits.js